import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { ComboBoxDataService } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ComboBoxDataService";
import { Dialog, DialogPropertyValues, IDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Dialog";
import { PropertyEditor } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditor";
import { NAMESPACE } from "./_Namespace";

export type ProcessVersionInstanceSelectDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type ProcessVersionInstanceSelectDialogProperties = {
    [name in keyof ProcessVersionInstanceSelectDialogPropertyValues]: Property<ProcessVersionInstanceSelectDialogPropertyValues[name]>
};

export interface IProcessVersionInstanceSelectDialog extends IDialog, ProcessVersionInstanceSelectDialogProperties
{
}

export class ProcessVersionInstanceSelectDialog extends Dialog implements IProcessVersionInstanceSelectDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ProcessVersionInstanceSelectDialog";
    public static override className = "ProcessVersionInstanceSelectDialog";

    // #region Properties

    public static instance = new ProcessVersionInstanceSelectDialog();

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ProcessVersionInstanceSelectDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
                title: "Select process",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected comboBoxDataServiceProcess?: ComboBoxDataService;
    protected propertyEditorProcess?: PropertyEditor;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ProcessVersionInstanceSelectDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    public openSuperAsync()
    {
        return super.openAsync();
    }

    // #endregion

    // #region Protected Methods

    protected _updateLayout()
    {
        Assert.isNotNullOrUndefined(this.buttonOk, "this.buttonOk");
        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");

        this.buttonOk.enabled.set(this.propertyEditorProcess.value.get() !== null);
    }

    // #endregion

    // #region Overrides

    protected override _bindEvents()
    {
        super._bindEvents();

        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");

        this.propertyEditorProcess.on("valueChanged", { self: this }, this.onPropertyEditorProcessValueChanged);
    }
    protected override _createElement()
    {
        const
            $$element = super._createElement();

        Assert.isNotNullOrUndefined(this.buttonOk, "this.buttonOk");

        this.comboBoxDataServiceProcess = new ComboBoxDataService({
            dataServiceId: "b185975f-0e14-4944-b706-6353f0d67dc4",
            dataServiceOperation: "ListProcessesForEntity",
        });

        this.propertyEditorProcess =
            new PropertyEditor({
                editMode: true,
                editorControl: this.comboBoxDataServiceProcess,
                propertyDisplayName: "Process",
                mandatory: true,
            })
                .appendTo(this._containerElementRef.current);

        this.buttonOk.enabled.set(false);

        return $$element;
    }

    public override async closeAsync()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");

        this.promiseData = {
            processVersionId: this.propertyEditorProcess.value.get()
        };

        await super.closeAsync();
    }
    public override async openAsync(entityName: string)
    {
        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");
        Assert.isNotNullOrUndefined(this.comboBoxDataServiceProcess, "this.comboBoxDataServiceProcess");

        this.propertyEditorProcess.value.set(null);

        this.comboBoxDataServiceProcess.dataServiceData.set(ObjectHelper.toJson({
            entityName: entityName
        }));

        await this.propertyEditorProcess.loadDataAsync();
        return await super.openAsync();
    }

    // #endregion

    // #region Event Handlers

    protected onPropertyEditorProcessValueChanged(evt: IJNativeEvent)
    {
        const
            self = evt.data.self as this;

        self._updateLayout();
    }

    // #endregion

    // #endregion
}

